import { Spin } from "antd";
import moment from "moment";
import { MdDelete } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { IoIosWarning } from "react-icons/io";
import ReactS3Client from "react-aws-s3-typescript";
import { FileUploader } from "react-drag-drop-files";
import { useForm, SubmitHandler } from "react-hook-form";
import { useParams, useLocation, useNavigate } from "react-router-dom";

import Breadcrumb from "Components/Breadcrums";
import FormControl from "Components/FormControl";
import Imagepreview from "Components/ImagePreview";
import Upload from "Components/UploadDesign/upload";
import { showErrorAlert, showWarningAlert, Toast } from "Util/Alerts";

import { config } from "../../../s3config";
import { breadcrumbItems } from "./Constant";
import { BannerInputs } from "./BannerTypes";
import { add_Banners, update_Banners, uploadImage } from "Services/Requests";
import Styles from "Styles/Styles.module.css";

window.Buffer = window.Buffer || require("buffer").Buffer;

function AddBanner() {
    const navigate = useNavigate();
    const fileTypes = ["JPG", "PNG", "JPEG"];
    const { type } = useParams();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

    const [BannerImg, setBannerImg] = useState("");
    const [ErrorMsg, setErrorMsg] = useState<null | string>(null);

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        resetField,
        reset,
        watch,
        setError,
    } = useForm<BannerInputs>();

    const handleChange = async (files: any) => {
        setErrorMsg("");
        let maxSize = 2 * 1024 * 1024;
        if (files.size > maxSize) {
            alert("File size cannot be greater than 2 MB");
            return;
        }

        setLoading(true);
        let formData = new FormData();
        formData.append("image", files);
        formData.append("folder", "bannerImages");
        uploadImage(formData)
            .then((res: any) => {
                setValue("image_url", res.data?.image);
                setBannerImg(res.data?.url);
                setLoading(false);
            })
            .catch((err: any) => {
                alert(err);
                setLoading(false);
            });
    };

    const onSubmit: SubmitHandler<BannerInputs> = async (data) => {
        if (!BannerImg) {
            setErrorMsg("Please Upload File");
            return;
        }
        try {
            setLoading(true);
            let response;
            if (type === "edit") {
                response = await update_Banners(
                    location.state?.banner_id,
                    data
                );
            } else {
                response = await add_Banners(data);
            }
            if (response?.data?.status === 1) {
                Toast(response?.data?.Message, "success");
                navigate(-1);
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong, try again later"
            );
        } finally {
            setLoading(false);
        }
    };

    const watchData = watch();

    useEffect(() => {
        if (type === "edit") {
            let formData = location.state;
            formData = {
                ...formData,

                image_url: String(formData.image_url).split("/")[
                    String(formData.image_url).split("/").length - 1
                ],
            };
            reset({ ...formData });
            setBannerImg(location.state?.image_url);
        }
    }, [type, location.state, reset]);

    return (
        <div className={Styles["Add_form_wrapper"]}>
            <Imagepreview
                handleCancel={() => setIsModalVisible(false)}
                selectedImage={BannerImg}
                isModalVisible={isModalVisible}
                title="banner"
            />
            <h3>
                <span style={{ textTransform: "capitalize" }}>{type}</span>{" "}
                Banner
            </h3>
            <Breadcrumb items={breadcrumbItems} type={type} />
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={Styles["form"]}>
                    <h4>Banner</h4>
                    <FormControl
                        key={"type"}
                        label={"Type"}
                        name={"type"}
                        register={register}
                        errors={errors["type"]}
                        requiredMessage={"this field is required"}
                        type={"select"}
                        options={[
                            { value: 1, label: "Home Banner" },
                            { value: 2, label: "Promotional Banner" },
                        ]}
                    />
                    <div className={Styles["form_control"]}>
                        <label htmlFor="Photo">Photo</label>
                        <FileUploader
                            handleChange={handleChange}
                            name="file"
                            types={fileTypes}
                            children={Upload}
                        />
                        <span style={{ fontSize: "0.9rem" }}>
                            Upload an image with dimensions of 400x185.
                        </span>
                        {BannerImg && (
                            <div className={Styles["remove_upload"]}>
                                <div onClick={() => setIsModalVisible(true)}>
                                    <img src={BannerImg} alt="banner" />
                                    {/* <p>{watchData.image_url}</p> */}
                                </div>
                                <button
                                    onClick={() => {
                                        resetField("image_url");
                                        setBannerImg("");
                                    }}>
                                    <MdDelete />
                                </button>
                            </div>
                        )}

                        {type == "edit" && (
                            <FormControl
                                key={"status"}
                                label={"Status"}
                                name={"status"}
                                register={register}
                                errors={errors["status"]}
                                requiredMessage={"this field is required"}
                                type={"select"}
                                options={[
                                    { value: 1, label: "Active" },
                                    { value: 0, label: "Inactive" },
                                ]}
                            />
                        )}
                    </div>
                    {ErrorMsg && (
                        <p className={Styles["Gen-erro_msg"]}>
                            <IoIosWarning /> {ErrorMsg}
                        </p>
                    )}
                </div>

                {loading ? (
                    <Spin size="default" />
                ) : (
                    <button>{type === "edit" ? "Update" : "Add"}</button>
                )}
            </form>
        </div>
    );
}

export default AddBanner;
